import LoadingDots from '@/assets/LoadingDots.json';
import Lottie from 'react-lottie';
import React from 'react';

const LoadingComponent: React.FC = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LoadingDots,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return <Lottie options={defaultOptions} height="6.24994rem" width="4.95538rem" />;
};

export default LoadingComponent;
